import React from "react";
import PartyCategory from "../assets/images/PartyCategory.png";
import BeachCategory from "../assets/images/BeachCategory.png";
import CultureCategory from "../assets/images/CultureCategory.png";
import CityCategory from "../assets/images/CityCategory.png";
import {PartyCategoryIcon} from "../assets/svgComponents/categoryIcons/partyCategoryIcon";
import {BeachCategoryIcon} from "../assets/svgComponents/categoryIcons/beachCategoryIcon";
import {CityCategoryIcon} from "../assets/svgComponents/categoryIcons/cityCategoryIcon";
import {CultureCategoryIcon} from "../assets/svgComponents/categoryIcons/cultureCategoryIcon";
import CategoryCard from "./cards/categoryCard";
import {DestinationCategory} from "../models/DestinationCategory";
import {getCategoryLabel, useTranslation} from "../i18n/LanguageProvider";

const CategoryQuickSelect: React.FC = () => {
  const {t} = useTranslation();

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 w-full max-w-3xl p-0 sm:p-4 gap-3 sm:gap-4">
      <CategoryCard title={getCategoryLabel(DestinationCategory.PARTY, t)} icon={<PartyCategoryIcon/>} imageUrl={PartyCategory} categoryId={DestinationCategory.PARTY} />
      <CategoryCard title={getCategoryLabel(DestinationCategory.BEACH, t)} icon={<BeachCategoryIcon />} imageUrl={BeachCategory} categoryId={DestinationCategory.BEACH} />
      <CategoryCard title={getCategoryLabel(DestinationCategory.CITY, t)} icon={<CityCategoryIcon />} imageUrl={CityCategory} categoryId={DestinationCategory.CITY} />
      <CategoryCard title={getCategoryLabel(DestinationCategory.CULTURE, t)} icon={<CultureCategoryIcon />} imageUrl={CultureCategory} categoryId={DestinationCategory.CULTURE} />
    </div>
  );
};

export default CategoryQuickSelect;
